import { useCallback, useEffect, useState } from "react"

const TIMER_COUNTDOWN = 20

export const useTimeCountDown = (timerCountDown = TIMER_COUNTDOWN) => {
  const [timeLeft, setTimeLeft] = useState(timerCountDown)

  useEffect(() => {
    if (timeLeft === 0) return

    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1)
    }, 1000)

    return () => clearInterval(intervalId)
  }, [timeLeft])

  const resetTimer = useCallback(() => setTimeLeft(timerCountDown), [timerCountDown])

  return { resetTimer, setTimeLeft, timeLeft }
}
